export const SEGMENT_EVENTS = {
    SessionDraftCreated: {
        key: 'SessionDraftCreated',
        properties: ['programWorkoutId', 'dateOfTargetSession', 'calendarType']
    },
    SessionPublished: {
        key: 'SessionPublished',
        properties: [
            'userId',
            'email',
            'calendarType',
            'programWorkoutId',
            'blockCount',
            'dateSessionPrescribed'
        ]
    },
    SessionPublishedAll: {
        key: 'SessionPublishedAll',
        properties: [
            'userId',
            'email',
            'calendarType',
            'numSessions',
            'teamId',
            'programId',
            'dateFirstSession',
            'dateLastSession'
        ]
    },
    UpgradeNowClicked: {
        key: 'UpgradeNowClicked',
        properties: ['userId', 'currentSubscriptionPlan', 'daysLeftInTrial']
    },
    TeamAppLaunched: {
        key: 'TeamAppLaunched',
        properties: ['userId', 'page']
    },
    LeaderboardViewed: {
        key: 'LeaderboardViewed',
        properties: ['userId', 'page']
    },
    WhiteboardViewed: {
        key: 'WhiteboardViewed',
        properties: ['userId', 'page']
    },
    SpreadsheetsListViewed: {
        key: 'SpreadsheetsListViewed',
        properties: ['userId', 'page']
    },
    ClickCTA: {
        key: 'ClickCTA',
        properties: ['sources', 'ctaLocation', 'ctaText']
    },
    AddToCalendarCTA: {
        key: 'AddToCalendarCTA',
        properties: ['sources', 'ctaLocation', 'ctaText']
    },
    FeatureViewed: {
        key: 'Feature Viewed',
        properties: ['feature', 'location', 'details']
    },
    FeatureEngaged: {
        key: 'Feature Engaged',
        properties: ['feature', 'location', 'details']
    }
};
